var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-wrapper"},[_c('div',{ref:"selected",staticClass:"s-selected disabled"},[_vm._v(" "+_vm._s(_vm.payload.message)+" "),_c('img',{ref:"image",attrs:{"src":require("@/assets/icn-arrow-down.svg"),"alt":"Arrow"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }